import React, { useState } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { StatsLeadersNav } from '../components/StatsLeaders/StatsLeadersNav';
import { StatsLeadersFilters } from '../components/StatsLeaders/StatsLeadersFilters';
import { StatsLeadersTableHeader } from '../components/StatsLeaders/StatsLeadersTableHeader';
import { StatsLeadersTable } from '../components/StatsLeaders/StatsLeadersTable';
import { BenchmarkingHeader } from '../components/StatsLeaders/BenchmarkingHeader';
import { getTranslation } from '../../../../../common/react/utils/translations';

export const StatsLeadersProvider = ( { store } ) => {
    const [
        areFilterOptionsVisible,
        setAreFilterOptionsVisible
    ] = useState( false );

    return (
        <Provider store={store}>
            <div className="wrapper mb-0" style={{ paddingBottom: '2rem' }}>
                <div className="u-sl-shadow" style={{ marginBottom: '1.6rem' }}>
                    <StatsLeadersNav>
                        <button
                            onClick={ () =>
                                setAreFilterOptionsVisible( prev => !prev )
                            }
                        >
                            { getTranslation( 'label.statsLeaders.filters.toggleButtonText' ) }
                        </button>
                    </StatsLeadersNav>
                    { areFilterOptionsVisible && (
                        <StatsLeadersFilters />
                    ) }
                </div>

                <div className="u-sl-shadow">
                    <StatsLeadersTableHeader />
                    <BenchmarkingHeader />
                    <StatsLeadersTable />
                </div>
            </div>
        </Provider>
    );
};

StatsLeadersProvider.propTypes = {
    store: PropTypes.object.isRequired
};